import React from 'react';
import {Button, DialogActions, DialogContent, Grid, TextField} from "@mui/material";
import {DatePicker} from "@mui/x-date-pickers";
import dayjs from "dayjs";
import floatParser from "src/helpers/floatParser";
import LogbookApi from "src/api/staffApi/logbookApi";

export interface IHesapKayitFormValues {
    id?: number;
    hesapId: number;
    tarih: string;
    degisim: number;
    aciklama?: string;
}

export const defaultHesapKayitValues = (hesapId: number): IHesapKayitFormValues => ({
    id: 0,
    hesapId: hesapId,
    tarih: dayjs(new Date(Date.now() - 5 * (60 * 60 * 1000))).format("DD-MM-YYYY"),
    aciklama: "",
    degisim: 0
});

interface HesapKayitFormProps {
    kayit: IHesapKayitFormValues;
    setKayit: (val: IHesapKayitFormValues) => void;
    onClose: () => void;
    onSuccess: (res: any) => void;
    mode: 'add' | 'edit';
}

const HesapKayitForm: React.FC<HesapKayitFormProps> = ({kayit, setKayit, onClose, onSuccess, mode}) => {
    const handleSave = () => {
        const promise = mode === 'add'
            ? LogbookApi.postHesapKayit(kayit)
            : LogbookApi.putHesapKayit(kayit);

        promise.then(res => {
            onSuccess(res);
            onClose();
        });
    };

    return (
        <>
            <DialogContent>
                <Grid container spacing={2} sx={{mt: 0.5}}>
                    <Grid item xs={12} sm={6}>
                        <DatePicker
                            label="Tarih"
                            sx={{width: "100%"}}
                            value={dayjs(kayit?.tarih, "DD-MM-YYYY")}
                            disableFuture
                            onChange={newValue => setKayit({
                                ...kayit,
                                tarih: newValue ? newValue.format("DD-MM-YYYY") : ""
                            })}
                        />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <TextField
                            fullWidth
                            label="Değişim"
                            type="number"
                            value={kayit.degisim}
                            onChange={(event) => setKayit({
                                ...kayit,
                                degisim: floatParser(event.target.value)
                            })}
                        />
                    </Grid>
                    <Grid item xs={12}>
                        <TextField
                            label="Açıklama"
                            value={kayit.aciklama || ""}
                            fullWidth
                            multiline
                            rows={2}
                            onChange={(event) => setKayit({...kayit, aciklama: event.target.value})}
                        />
                    </Grid>
                </Grid>
            </DialogContent>
            <DialogActions sx={{px: 3, pb: 2}}>
                <Button variant="outlined" color="secondary" onClick={onClose}>
                    Kapat
                </Button>
                <Button variant="contained" color="primary" onClick={handleSave}>
                    {mode === 'add' ? 'Ekle' : 'Güncelle'}
                </Button>
            </DialogActions>
        </>
    );
};

export default HesapKayitForm;
